import { Button } from '@chronosphereio/chrono-ui';
import { useCallback } from 'react';
import { useQueryEditorContext } from './query-editor-context';

/**
 * Standalone clear control for use inside a QueryEditor. Reads value/onChange
 * from the nearest QueryEditor.Root's context — that is the entire contract.
 
 * Typically rendered via QueryEditor.Input's `endAdornment` prop.
 * This is NOT part of the QueryEditor.* dot-notation namespace.
 */
export function ClearAction() {
  const { value, onChange } = useQueryEditorContext();
  const handleClear = useCallback(() => onChange(''), [onChange]);

  if (!value) return null;

  return (
    <Button variant="tertiary" size="small" onClick={handleClear} aria-label="Clear query">
      Clear
    </Button>
  );
}
